import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { defaultState } from './types';

export default {
  namespaced: true,
  state: defaultState,
  mutations,
  getters,
  actions
};
